/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PreviewCalendarEntryDto } from '../models/PreviewCalendarEntryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarService {
    /**
     * @param teamId
     * @param startDate
     * @param endDate
     * @returns PreviewCalendarEntryDto OK
     * @throws ApiError
     */
    public static getPreviewCalendar(
        teamId: number,
        startDate: string,
        endDate: string,
    ): CancelablePromise<Array<PreviewCalendarEntryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/calendar/preview/{teamId}',
            path: {
                'teamId': teamId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
}
